<script>
  import widgetColors from 'utils/design/chartColors';

  const DEFAULT_COLORS = widgetColors();

  export default {
    name: 'ColorGetterMixinBase',
    props: {
      colorGetter: {
        type: Object,
        default: null
      }
    },
    computed: {
      entityType () {
        return this.grouping;
      },
      chartColors () {
        if (this.colorGetter) {
          return this.getColorsListForEntities();
        }

        return DEFAULT_COLORS;
      }
    },
    methods: {
      getColorsListForEntities () {
        return DEFAULT_COLORS;
      }
    }
  };
</script>
